module.exports = __webpack_public_path__ + "static/media/PERL-BNB.d554d6bc.svg";